export default __webpack_public_path__ + "static/media/img4.c64d141e.png";